export default __webpack_public_path__ + "static/media/logo.756e45a4.png";